/* eslint-disable import/no-anonymous-default-export */
export default {
  language: 'en',
  base: {
    back_btn: 'Return to HOME',
    email: 'Email',
    password: 'Password',
    confirm: 'Confirm',
    tCO2e: 'tCO2e',
    update: 'Update',
    update2: 'Update',
    upload: 'Upload',
    cancel: 'Cancel',
    cancel2: 'Cancel',
    add: 'Add',
    add2: 'Add',
    logout: 'Logout',
    do_you_want_to_logout: 'Do you want to logout?',
    all: 'All',
    no_data_to_display:
      'No data to display.\nPlease upload your data and try again.',
    delete: 'Delete',
    delete_short: 'Del',
    no_items: 'There are no results that match your search.',
    add_new_option: 'Create :',
    chart_sp:
      'To view this chart, rotate your device sideways or view it on your tablet or PC.',
    required: 'Required',
    optional: 'Optional',
    yen: 'JPY',
    usd: 'USD',
    menu: 'Menu',
    unit: 'Unit',
    user_guide: 'User guide',
    no_result_found: 'No results found.',
    select_all_options: 'Select all options',
    scope_1_cost_trends_by_fuel_types: 'Scope 1 cost trends by fuel types',
    cost_trends_by_fuel_types: 'Changes in fuel costs',
    enter_character_to_search: 'Enter text to search',
    placeholder_manual_input: 'Enter text to search',
    noti_upload_image:
      '※This system is only available for premium plan. Images and documents can be managed.',
    type_input: 'APPLY',
    search: 'Search',
    view_analysist: 'View Analytics',
    close: 'Close',
    year: 'Year',
    back_to_default: 'BACK TO DEFAULT',
    search_by_condition: 'Search by condition',
    close_by_condition: 'Close conditional search',
    reload: 'Reload',
    option_default: {
      all: 'All',
      electricity: 'Electricity',
    },
    change: 'Modify',
    load_more: 'See more',
    loading: 'Loading...',
    mark_as_read: 'Mark as read',
    approve: 'Approve',
    back_to_prev: 'Back to previous',
    back_to_previous_page: 'Back to previous',
    detail: 'Detail',
    new_addition: 'New addition',
    clear_conditions: 'Remove filter',
    choice: 'Select saved filter',
    save: 'Save',
    filter: 'Filter name',
    new: 'New',
    draft: 'Draft',
    result: 'Results',
    confirm_download_csv:
      'Do you want to start CSV output under the specified conditions?<br></br>*Scopes 1 to 3 will all be output.',
    download: 'Download',
    export_csv: 'Export CSV',
    request: 'Request',
    status: 'Status',
    scope: 'Scope',
    ok: 'OK',
    total: 'Total CO2 emissions',
    year_number: 'Year {{year}}',
    done: 'Done',
    clear: 'Clear',
    unique: 'Unique',
    edit: 'Edit',
    copy: 'Copy',
    view: 'View',
    file: 'File',
    send: 'Send',
    calculate_year: 'Calculation year',
    save_filter: 'Save filter',
    kudan: '{{number}} items',
    pin_this: 'Pin this',
    unpin: 'Unpin',
    can_not_pin: 'You can pin up to four items.',
    title_filter: 'Filter settings',
    unique_coefficient: 'unique coefficient',
    add_row_btn: 'Add row',
    preview: 'Preview',
  },
  login: {
    login: 'Login',
    policy: 'Privacy Policy',
    copy_right: '© 2023 tansomanGX Co., Ltd.',
    forgot_password: 'Forgot Password?',
    save_login: 'Remember me',
    register_account: ' Sign up here',
    dont_have_account: "Don't have an account?",
    please_enter_email: 'Please enter your e-mail address',
    go_to_forgot_password: 'Click here to reset your password',
    do_not_have_account: "If you don't have an account",
    go_to_register: 'Click here to create an account',
  },
  nav: {
    data: 'Home',
    analysis: 'Analysis',
    all: "Organization's total emissions",
    scope1: 'Scope 1',
    scope2: 'Scope 2',
    scope3: 'Scope 3',
    other_analysis: 'Other',
    other_analysis_full: 'Other analysis',
    report: 'List of graphs',
    emissions: 'Emissions',
    registration: 'Registration',
    register_emissions: 'Register Emissions',
    list_of_registration: 'List of Emission Registration Data',
    emission_intensity: 'Emission Intensity',
    facility_management: 'Branch/Facility',
    base_management: 'Facility',
    my_account: 'Profile',
    settings: 'Setting',
    image_management: 'Image Management',
    change_password: 'Change Password',
    change_usage_plan: 'Change Usage plan',
    help: 'Help',
    user_guide: 'Usage Guide',
    faq: 'FAQ',
    contact_us: 'Contact Us',
    tutorial: 'Tutorial',
    other: 'Other',
    logout: 'Log Out',
    notifications: 'Notice',
    user_management_title: 'User Management',
    subsidy: 'File',
    company_setting: 'Organization',
    linkage_management: 'Share',
    request_management: 'Affiliated companies list',
    shared_emissions: 'Collaboration status management',
    premium: 'Premium',
    goal_setting: 'Target',
    representative: 'Representative',
    cutoff_demo: 'Demo Reduction Plan',
    versions: 'Reduction Value Setting',
    cutoff: 'Reduction Plan',
    simulation: 'Reduction forecast image',
    emission_policy: 'Emission policy',
    history_title: 'インポートしたデータは下の一覧からダウンロードできます。',
  },
  sub_title: {
    register_emissions:
      "Let's input the quantity and cost data for the products or services our organization has purchased or acquired.",
    list_of_registration: "You can manage your organization's emissions",
    list_of_registration_refer:
      'If you are unsure of what to register, please refer to this <a>glossary</a>.',
    analysis: {
      all: "You can view the status of registered organizations and each branch/facility by scope. Let's take a look at the data and analyze the CO2 emissions.",
      scope1:
        "You can view the status of registered organizations and each branch/facility by scope. Let's take a look at the data and analyze the CO2 emissions.",
      scope2:
        "You can view the status of registered organizations and each branch/facility by scope. Let's take a look at the data and analyze the CO2 emissions.",
      scope3:
        "You can view the status of registered organizations and each branch/facility by scope. Let's take a look at the data and analyze the CO2 emissions.",
    },
    emission_intensity:
      "On this page, you can conveniently review the registered emissions categorized by scope. Let's check the CO2 emissions per unit of activity.",
    branch:
      "At TansoCheck, we input organization activity data for each location to calculate CO2 emissions. Let's start by registering the locations, enabling management and analysis for each facility.",
    user: 'You can manage and restrict user access, as well as add new users.',
    subsidy:
      'You can create folders here and manage your files. Excel files can be uploaded.',
    csv_input:
      "Let's input the quantity and cost data for the products or services our organization has purchased or acquired in bulk using Excel data.",
    other_company_data:
      'You can check detailed emissions data of other affiliated organizations',
    sub_emission_policy:
      'This explains the source of the emission factors used in TansoCheck.',
    check_and_edit_uploaded_data: 'Check and edit uploaded data',
    select_data_to_upload: 'Select data to upload',
  },
  languages: {
    jp: '日本語',
    en: 'English',
  },
  message: {
    change_password_success: 'Change password successfully',
    please_upload_five_files: 'Please upload up to 5 files per record.',
    please_upload_five_folder_files:
      'The number of files to be uploaded at once is 5 files.',
    max_size_upload:
      'The file size exceeds 10MB. Please uploading it under 10MB.',
    max_size_storage:
      'The upload failed.\nIt exceeds the capacity. Please increase available space and try again.',
    max_length_folder_file_name:
      'The file name can include maximum {{length}} characters.',
    unsupported_file_extentions_upload:
      'Please upload the file in Excel format',
    unsupported_file_extentions: 'Contains unsupported file extensions.',
    unsupported_file_size: 'Contains files larger than 10MB.',
    require: 'This field is required.',
    max_value_input_number: 'Please enter 9 digits or fewer.',
    email_already_exist: 'This email address is already registered.',
    email_invalid: 'Email is invalid.',
    phone_invalid: 'Phone is invalid.',
    duplicate_email: 'This email address is already registered.',
    invalid_password:
      'Password must have at least 8 characters include alphabet and number.\nMaybe have symbols: @#$!%^*?&()-=_+',
    invalid_login_password: 'Email or password is incorrect',
    invalid_regex_password:
      'Password must have at least 8 characters include alphabet and number.\nMaybe have symbols: @#$!%^*?&()-=_+',
    invalid_password_registration_user:
      'Password must have at least 8 characters include alphabet and number.\nMaybe have symbols: @#$!%^*?&()-=_+',
    clear_password:
      'The current password must be cleared before changing the password.',
    email_not_exist: 'The email address does not exist.',
    incorrect_login: 'Invalid email or password.',
    faild_invalid: 'Please fill in the required fields.',
    faild_number: 'Value is invalid.',
    current_password_invalid: 'Current password is invalid.',
    user_inactive: 'Account inactive. Please check again.',
    no_option: 'There are no options, please input to create the new one',
    empty_notification: 'No notifications',
    delete_permanently: 'The file has been deleted.',
    restore_file: '{{fileName}} has been restored.',
    empty_folder_table: 'There is no data.',
    branch_exist: 'Branch is exist.',
    add_data_success: 'Data has been added successfully',
    register_user_success:
      'The guidance has been sent to the registered email address.',
    update_data_success: 'Data has been updated successfully',
    register_data_success: 'Register data successfully.',
    division_exist: 'Division is exists',
    company_exist: 'The organization existed',
    user_not_found: 'User not found',
    user_activated: 'The user has been activated',
    resend_email_success: 'The email has been successfully resent',
    token_invalid: 'Token is invalid',
    branch_not_found: 'Branch not found',
    emission_not_found: 'Emission not found',
    register_data_not_found: 'Register data not found',
    delete_success: 'Delete successfully',
    password_not_match: 'Password do not match',
    company_not_match:
      'There is no matching organization code. Please enter a different organization code.',
    company_request_exist: 'The relevant organisations are working together.',
    company_collaboration_exist:
      'The application for collaboration with the relevant organization has been approved.',
    unshared_data_success: 'Data successfully unshared',
    search_condition_existed: 'Search condition name already existed',
    save_data_success: 'Save data successfully',
    request_share_is_existed: 'A request for this information already exists',
    invalid_number: 'Please enter 0 or more',
    invalid_format_number:
      'Please enter up to 10 digits before the decimal point and 1 digits after the decimal point.',
    approve_successfull: 'Approve successful',
    please_upload_file: 'Please upload file',
    not_have_facilities: 'There is no facilities.',
    update_group_successful: 'Update group successfully',
    register_fiscal_year_start_month: `Fiscal year starts in {{month}} [<style>edit</style>]`,
    please_input_this_field: 'Please input into this field',
    duplicate_success: 'Duplicated successfully',
    base_year_not_set:
      'The base year has not been set yet. Please set the base year.',
    can_not_be_empty: 'Please fill in this field.',
    version_not_found: 'Version not found',
    version_name_exist: 'Version name is exists',
    can_not_update_base_year: '※The base year cannot be updated once set.',
    confirm_save_base_year:
      'The base year cannot be changed. Are you sure you want to confirm this?',
    no_data: 'There is no data',
    enter_number_greater_than: 'Please enter a number greater than {{number}}.',
    item_exist: 'Item already exists.',
    token_expired: 'Token expired',
    half_width_number: 'Please enter numbers in half-width characters.',
    invite_success: 'Cooperation has been sent.',
    total_emission_is_not_entered:
      'You have not yet entered your total emissions for the base year [tCO2e]. Please enter this before setting your reduction target!',
    warning_change_financial_month:
      "*If you change the start month, your company's unique coefficients may not be referenced correctly or may not be referenced at all.",
    not_be_referenced: 'This factor is either not present or has been changed.',
    copy_emission_reselect:
      'The factor of the copied data is no longer available, so the selection has been cleared. Please select it again.',
    copy_item_reselect:
      'The item of the copied data is not available for the selected facility and month, so the selection has been cleared. Please select it again.',
    validation: {
      activity_amount_too_large:
        'The activity amount is too large. Please enter a smaller value.',
    },
    confirm_delete_emission_title:
      'Are you sure you want to delete this emission factor?',
    confirm_delete_emission_checkbox:
      'Any emission data registered with this emission factor will be deleted.',
    warning_change_scope:
      'You are currently entering data. If you move to another tab, the data you entered will be lost. Do you want to continue?',
    confirm_delete_branch_title: 'Are you sure you want to delete this branch?',
    confirm_delete_branch_checkbox:
      'Any emission data registered to this branch will be deleted.',
  },
  forgot_password: {
    forgot_password: 'Forgot your password?',
    description_top:
      'You will need your registered email address to reset your password.',
    description_bottom:
      'Enter your email address and click the "Send" button to receive a confirmation email, then follow the instructions to reset your password.',
    email_address: 'Email address',
    please_enter_email: 'Please enter your email address',
    send: 'SEND',
    back_to_login: 'Back to Login',
    send_mail_success:
      'We have received your password reset request.\nIf the email address you provided is registered and your account is active, we will send you an email with instructions on how to reset your password',
  },
  resend_verify_account: {
    title: 'Resend the account activation email',
    description:
      'Would you like to resend the account activation email to {{ email }}?',
  },
  reset_password: {
    change_password: 'Reset Password',
    description: 'Please enter new password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    change: 'CHANGE',
    password_not_match: 'Password does not match.',
    message_success: 'Reset password successfully.',
  },
  sidebar: {
    drop_invoices: 'File here \n Drop and upload',
    or: 'OR',
    or2: 'or',
    select_file: 'Select Files',
    select_a_file: 'Select a file',
  },
  dashboard: {
    home: {
      eyebrow: 'Organization overview',
      title: 'Organization-wide emissions',
      kpi_aria: 'Key figures',
      total: 'Total emissions',
      scope1: 'Scope 1',
      scope2: 'Scope 2',
      scope3: 'Scope 3',
      month: '',
      fiscal_year: '',
      previous_year: 'Previous year',
      previous_short: 'Prev.',
      share_short: 'Share',
      vs_previous_year: 'YoY',
      vs_same_period: 'YoY (same period)',
      ytd_short: 'YTD',
      in_progress: 'in progress',
      data_through: 'through {{month}} ({{count}} months)',
      monthly_title: 'Monthly emissions',
      branches_title: 'Emissions by site',
      top_n_of: 'Top {{n}} of {{total}} sites',
      goal_title: 'Reduction target progress',
      annual_title: 'Fiscal-year trend',
      categories_title: 'Scope 3 by category',
      sources_title: 'Top emission sources',
      sources_note: 'Scope 1 & 2 items',
      table_title: 'Fiscal-year summary (table)',
      annual_note: '{{year}} is still in progress; the bar shows the year-to-date total.',
      table_note:
        'Values in parentheses are year-over-year changes. Scope 2 uses the coefficient selected above (market / location).',
      view_detail: 'Details',
      view_all: 'View all',
      no_data: 'No data',
      no_branch: 'No site',
      other: 'Other',
      goal: {
        premium_only: 'Reduction targets are available on the Premium plan.',
        not_set: 'No reduction target has been set yet.',
        set_goal: 'Set a target',
        achieved: 'achieved',
        no_actual: 'waiting for actuals',
        vs_target: 'vs {{year}} target',
        base: 'Base ({{year}})',
        actual: 'Actual ({{year}})',
        target: 'Target ({{year}})',
      },
      empty: {
        title: 'No emission data yet',
        body: 'Once you register emissions, Scope breakdowns, monthly trends and site comparisons will appear here.',
        register: 'Register emissions',
        guide: 'Open the user guide',
      },
    },
    let_use_tanso_check: 'How to use the product',
    view_emission_intensity_new: 'Registration of each base',
    entering_cacbon_emission: 'Energy Amount Input.',
    view_emission_button: 'View Emission Intensity',
    register_emission_button: 'Register Emissions',
    entering_cacbon_emission_des:
      'After completing the input of facility information, proceed to register carbon emissions on the emission page, making sure to check the Emission Intensity.',
    co2_status_check: 'Analyze energy quantity',
    co2_status_check_button: 'Analyze emissions',
    co2_status_check_des:
      'View and analyze the energy usage status of your entire organization or each location',
    click_here_to_see_detail: 'If you want to learn more, click here:',
    user_guide: 'Usage guide',
    faq: 'FAQ',
    total_emissions: 'Overall organization emissions',
    main_energy_data: 'Main energy data',
    total_emissions_group: {
      title: 'Overall organization emissions',
      button_view: 'Detail',
      target_year: 'Fiscal year',
      option_default: 'All',
      year: 'Year',
      financial_year: 'FY',
      month: 'Month',
      scope_1: 'Scope 1',
      scope_2: 'Scope 2',
      scope_3: 'Scope 3',
    },
    information_table: {
      premium_require_single_line:
        'This feature is available only on premium plans. Images and documents can be managed.',
      premium_require_multi_line:
        'This feature is available only on premium plans.\nImages and documents can be managed.',
      premium_require_multi_line_sp:
        'This feature is\navailable only on premium plans.\nImages and documents can be managed.',
      total: 'Total',
      scope_3: 'Scope 3 breakdown',
    },
    direct_emissions: 'Direct emissions',
    indirect_emissions: 'Indirect emissions',
    detail: 'Detail',
    gasoline: 'Gasoline',
    scope1_Emissions: 'Scope 1 Emissions',
    scope2_Emissions: 'Scope 2 Emissions',
    city_gas: 'City gas',
    diesel: 'Diesel',
    tap_water: 'Tap water',
    paper: 'Parer',
    top_3_factory: 'Emission factor ranking',
    consumption_trend: 'Scope 1 Consumption Trends \n By Fuel Types',
    change_in_purchases:
      'Scope 2 Changes in purchases\n of Electricity, Stream, etc',
    monthly_emissions: 'Monthly Emissions Trends',
    change_electricity_consumption:
      'SCOPE2 is Changes in electricity  consumption \n and electricity charges',
    electricity_consumption: 'Electricity consumption ',
    electricity_charges: 'Electricity charges',
    fuel_charges: 'Fuel charges',
    cost: 'Cost',
    changes_in_emissions_by_facility: 'Changes in emissions \nby facility',
    coke: 'Coke',
    electricity: 'Electricity',
    notification: 'Notification',
    text_demo:
      '※Currently, it is a beta version before the service release. The official version will be released in early July. The design will change significantly, but the data will be accumulated, so you can still use the beta version.',
    emissions_per_scope: 'Emissions by Scope Chart',
    changes_by_scope: 'The transition by scope',
    other_data: 'Other data',
    table: {
      scope: 'Scope',
      category: 'Category',
      emission_tCO2e: {
        the_year_before_last: 'FY{{theYearBeforeLast}} emissions (tCO2e)',
        last_year: 'FY{{lastYear}} emissions (tCO2e)',
        current_year: 'FY{{currentYear}} emissions (tCO2e)',
      },
      Scope1_Direct_emissions: 'Scope 1 Direct emissions',
      Scope2_Direct_emissions: 'Scope 2 Indirect emissions',
      Scope3: 'Scope 3',
      premium: 'Premium',
      purchase: 'Purchase',
      Capital_Goods: 'Capital Goods',
      fuel_and_energy: 'Fuel-and Energy-related Activities',
      upstream_transportation: 'Upstream Transportation & Distribution',
      waste_generated: 'Waste Generated in Operation',
      bussiness_travel: 'Business Travel',
      employee_commuting: 'Employee Commuting',
      upstream_leased_assets: 'Upstream Leased Assets',
      downstream_transportation: 'Downstream Transportation & Distribution',
      processing_of_sold: 'Processing of Sold Products',
      use_of_sold: 'Use of Sold Products',
      end_of_life: 'End-of-life Treatment of Sold Products',
      Downstream_Leased_Assets: 'Downstream Leased Assets',
      Franchise: 'Franchise',
      Investments: 'Investments',
      other: 'Other',
      total_scope3: 'Total Scope 3',
      total: 'Total',
      rate_of_change: 'Rate of Change(YoY comparison)',
    },
    change_premium: 'AVAILABLE WITH PREMIUM PLAN',
    co2_emissions: 'CO2 emissions',
    notifications: 'Notifications',
    trivia: 'Trivia',
    total: 'Total',
    emission: 'Emissions',
    scope1: 'Scope 1',
    scope2: 'Scope 2',
    scope3: 'Scope 3',
    consumption_trends_by_fuel_types: 'Consumption Trends By Fuel Types',
    scope1_consumption: 'SCOPE 1 cost trends',
    scope3_consumption: 'SCOPE 3 cost trends',
    posted_by: 'Posted by:',
    date: 'Date:',
    one_direct_emissions: '1 Direct emissions',
    two_direct_emissions: '2 Indirect emissions',
    three_direct_emissions: '3 Other Indirect emissions',
    changes_in_the_amount_of:
      'Changes In The Amount Of Electricity And Steam Purchased',
    cost_trends_by_fuel_types: 'Changes in fuel costs',
    view_emission_intensity: 'View Emission Intensity',
    total_of_scope1: 'Total of Scope 1',
    total_of_scope2: 'Total of Scope 2',
    total_of_scope3: 'Total of Scope 3',
    changes_in_the_amount_Of_scope_3:
      'Changes In The Amount Of SCOPE 3 Emission',
    cost_trend_scope_3_emission: 'Cost Trends By SCOPE 3 Emission',
    main_energy: {
      gasoline: 'Trends in gasoline consumption and gasoline prices',
      city_gas: 'Trends in city gas consumption and city gas prices',
      diesel: 'Trends in diesel consumption and diesel prices',
      tap_water: 'Changes in water usage and water charges',
      paper: 'Trends in paper usage and paper prices',
    },
    charge: 'charges',
    consumption: 'consumption',
    scopeTotal: 'Total',
    total_emission_of_5_years: 'Total emissions over the past 5 years (tCO2e)',
    organization_wide_emissions: 'Organization-wide emissions (past 5 years)）',
    scope1_dashboard: 'Scope1',
    scope2_dashboard: 'Scope2 Market',
    scope2_location: 'Scope2 Location',
    scope3_dashboard: 'Scope3',
    total_dashboard: 'Total market',
    location_total: 'Total Location',
    market_based_coefficient: 'Market coefficient',
    location_based_coefficient: 'Location coefficient',
    denkicheck_banner: {
      label: 'Reduce emissions',
      title:
        'Switch to renewable energy and cut both CO2 emissions and electricity costs.',
      description:
        'Switching your electricity contract is an effective way to reduce Scope 2 emissions. DenkiCheck offers a free diagnosis of how much your electricity bill could be reduced.',
      button: 'Try DenkiCheck',
    },
  },
  analysis: {
    scope_description:
      'You can analyze emissions within your organization by limiting the scope to {{number}}.',
    name_filter: 'Please enter your name',
    year_last: '',
    month: 'Month',
    month_last: '',
    quarter: 'Quarter',
    quarter_last: '',
    search: 'Name (optional)',
    title_target: 'Select analysis target',
    select_from_company_or_location:
      'Select from organization and branch/facility',
    select_from_group: 'Select from group',
    placeholder_select_company: 'Please enter or select organization.',
    placeholder_select_branch: 'Please enter or select a location.',
    placeholder_select_group: 'Please enter or select a group name.',
    add_new_group: 'Add new group',
    title_target_year: 'Target analysis period',
    electric: 'Electric',
    tap_water: 'Tap water',
    option_target_year: {
      month_year: 'Calculation period',
      year: 'Fiscal year',
    },
    facility_emissions_comparison: 'Facility Emissions Comparison',
    all: {
      month: 'Month',
      year: '',
      csv_download: 'CSV DOWNLOAD',
      pdf_download: 'PDF DOWNLOAD',
      total_emissions: 'total CO2e emissions',
      total: 'Total',
      filter_settings: 'Filter Settings',
      save_filter_settings: 'Save Filter Settings',
      pdf_output: 'PDF Output',
      filter_title: 'Analysis Conditions',
      display_scope: 'Display Scope',
      display_year_month: 'Display Year/Month',
      monthly_display: 'Monthly Display',
      annual_display: 'Annual Display',
      select_year: 'Select Year',
      scope2_calculation_method: 'Scope 2 Calculation Method',
      market_based: 'Market-based',
      location_based: 'Location-based',
      display_base: 'Display Base/Location',
      select_from_base: 'Select from Base',
      select_from_group: 'Select from Group',
      select_base: 'Select Base',
      use_saved_search_conditions: 'Use saved search conditions',
      table: {
        category: 'Category',
        scope: 'Scope',
        co2: 'CO2 emissions (tCO2e)',
        ratio: 'Ratio',
        item: 'Item',
        one_direct_emissions: '1 Direct emissions',
        two_direct_emissions: '2 Indirect emissions',
        three_direct_emissions: '3 Other Indirect emissions',
      },
      no_data_to_display:
        'No data to display.\nPlease upload your data and try again.',
      no_data_in_period:
        'No data for the selected period ({{from}} - {{to}}).\nPlease change the period in the filter settings.',
      compare: 'Targets for comparison',
      back_to_default: 'Back to default',
      description: 'You can check the emissions of your entire organization.',
    },
    scope1: {
      type_of_analysis: 'Types of analysis',
      target_year: 'Fiscal year',
      csv_download: 'CSV DOWNLOAD',
      change_in_consumption: 'Changes in consumption by fuel type',
      change_in_consumption_scope2:
        'Changes in the amount of electricity and steam purchased',
      total_emissions: 'Total emissions',
      total_emissions_scope1: 'Total Emissions  (SCOPE 1)',
      total_emissions_scope2: 'Total Emissions  (SCOPE 2)',
      total__co2_emissions: 'total CO2e emissions',
      city_gas: 'City gas',
      gasoline: 'Gasoline',
      city_gas_liter: 'City gas (l)',
      tap_water: 'Tap water',
      gasoline_m3: 'Gasoline (m3)',
      gasoline_nm3: 'City gas (Nm3)',
      electricity: 'Electricity',
      text_scope3:
        'This feature is not available for contracted plans. \n Please contact us to change contracted plan.',
      top_emission: 'Top emissions',
      emission: 'Emission',
      diesel: 'Diesel',
      table: {
        year: 'Year',
        year_title: 'Year',
        item: 'Item',
        category: 'Category',
        emission_intensity: 'Emission Intensity',
        amount_to_use: 'Amount to use',
        usage: 'Usage',
        unit: 'Unit',
        individual: 'Individual CO2 emissions\n(tCO2e)',
        co2_emissions: 'CO2 emissions\n (tCO2e)',
        ratio: 'Ratio',
        emission_facotr: 'Emission Factor',
        tco2_2021: '2021（tCO2e）',
        tco2_2022: '2022（tCO2e）',
        tco2_2023: '2023（tCO2e）',
        month: {
          month1: '1',
          month2: '2',
          month3: '3',
          month4: '4',
          month5: '5',
          month6: '6',
          month7: '7',
          month8: '8',
          month9: '9',
          month10: '10',
          month11: '11',
          month12: '12',
        },
        total: 'Total',
      },
      changes_in_electricty: 'Changes in Electricity consumption and Charges',
      changes_in_electricity_consumption_and_electricity_charges:
        'Changes in Electricity Consumption and Charges',
      change_electricity_consumption:
        'Changes in electricity  consumption \nand electricity charges',
      scope: 'Scope',
      all: 'All',
      direct_emissions_1: '1 Direct emissions',
      indirect_emissions_2: '2 Indirect emissions',
      other_indirect_emissions: '3 Other indirect emissions',
      monthly_emissions_trend: 'Monthly emission trends',
      there_is_no_target: 'There is no target data.',
      select_organization: 'Selected organization data collection rate',
      enter_target:
        'Enter the target data from the upload function. \nThe analysis data can be used from the next day after uploading.',
      branch_name: 'Branch name',
      changes_in_emissions_by_facility: 'Changes in emissions by facility',
      comparison_across_facilities: 'Comparison of emissions of all facilities',
      data_collection_check: 'Data collection check',
      fuel_charges: 'Fuel charges',
      total: 'Scope 1 Total',
      cost_trends_by_fuel_types: 'Trends in Fuel Costs',
      total_emissions_breakdown: 'Breakdown of Total Emissions',
      monthly_emission_trend: 'Monthly Emission Trend (tCO2)',
    },
    scope2: {
      electricity_company: 'Electric Power Organization',
      menu: 'Menu',
      total: 'Total Scope 2',
      total_electric: 'Electricity supplied by other companies',
      total_industrial_stem: 'Heat supplied by other companies',
      emission_unit: 'Emission unit',
      group_by: 'Group By',
      group_by_item: 'Item',
      group_by_classification: 'Classification',
      scope2_calculation_method: 'Scope 2 Calculation Method',
      market_based: 'Market-based',
      location_based: 'Location-based',
      total_emissions_breakdown: 'Breakdown of Total Emissions',
      monthly_emission_trend: 'Monthly Emission Trend (tCO2)',
    },
    scope3: {
      total_emissions: 'Total emissions',
      changes_in_the_amount_Of_scope_3:
        'Changes in the amount of scope 3 emission',
      cost_trends_by_scope3: 'Cost trends by scope 3 emission',
      scope3_category_overview: 'Emissions by category',
      scope3: 'Scope 3',
      scope3_cost: 'SCOPE 3 Cost',
      category_overview: 'Emissions by category',
      total_scope3: 'Total Scope 3',
      emission_by_category: 'Emissions by Category',
      total_emissions_breakdown: 'Breakdown of Total Emissions',
      monthly_emission_trend: 'Monthly Emission Trend (tCO2)',
    },
    other: {
      description:
        'You can check the items with the highest emissions, as well as trends in emissions by facility/location, month, and year.',
      changes_in_emissions_by_year: 'Changes in emissions by fiscal year',
      main_energy_emission_trends: 'Trends in Main Energy Emissions',
    },
  },
  report: {
    co2_emission_report: 'CO2 Emission Report',
    target_company: 'Target Organization',
    target_period: 'Target Period',
    total_emissions: 'Total Emissions',
    monthly_emission_trends: 'Monthly Emissions Trends',
    direct_emissions: '1 Direct emissions',
    indirect_emissions: '2 Indirect emissions',
    other_emimissions: '3 other Indirect emissions',
    description: 'You can check various analysis graphs at a glance.',
    table: {
      scope: 'Scope',
      category: 'Category',
      note: 'Note',
      FY2021: 'FY2021\nemissions\n（tCO2e）',
      FY2022: 'FY2021\nemissions\n（tCO2e）',
      FY2023: 'FY2021\nemissions\n（tCO2e）',
      scope1_direct: 'Scope 1 Direct emissions',
      scope2_indirect: 'Scope 2 Indirect emissions',
      total: 'Total',
      export_to_pdf: 'EXPORT TO PDF',
      item: 'Item',
      growth: 'Growth Rate',
    },
    export_pdf: 'EXPORT TO PDF',
    note: 'Note',
    view_report: 'View Report',
    scope3: 'Scope 3',
    category_overview: 'Emissions by category',
    total_scope_3: 'Total Scope 3',
    total_of_scope3: 'Total of Scope 3',
  },
  setting: {
    branch: {
      sub_title: 'Facility info',
      country: 'Country',
      company: 'Organization',
      branch: 'Branch/Facility',
      status: 'Status',
      public: 'Public',
      do_you_want_to_delete: 'Do you want to delete?',
      private: 'Private',
      search_block: {
        placeholder: 'Select Facility',
        btnText: 'Search',
      },
      add_facility: 'ADD FACILITY',
      edit_facility: 'EDIT FACILITY',
      electricity_company: 'Electric Power Organization',
      choose_a_power_company: 'Select an electricity organization',
      select_box_placeholder: {
        countries: 'Choose a country',
      },
      guide_box: {
        guide_description: 'Because the base has not been registered yet,',
        no_match_data: 'There were no data matching the keyword.',
        note: "Let's register your facilities by using the<outline>「ADD FACILITY」<inlineStyle></inlineStyle></outline>button!",
      },
      edit: {
        title: 'Edit organization information',
        submit_button: 'Invite',
        placeholder: 'A factory, A plant',
      },
      all: 'All Facility',
    },
    user: {
      list_title: 'User Registration',
      edit_title: 'Edit members',
      member_info: 'Member information',
      affiliation: 'Affiliation',
      fullname: 'Full name',
      fullname_kana: 'Name katakana',
      email: 'Email address',
      password: 'Password',
      authority: 'Authority',
      status: 'Status',
      split: '分割',
      company: 'Organization',
      branch: 'Branch/Facility',
      edit_discription: `Users cannot be deleted from the settings screen. For suspension of use, please select "Inactive" in the usage status.`,
      search_block: {
        placeholder: 'Select Fullname / Email / Branch or Facility',
        btnText: 'Search',
      },
      add_user: 'Add members',
      add_user_btn: 'Add',
      add_user_btn_title: 'Add members',
      table_title: {
        full_name: 'Full name',
        mail_address: 'Email address',
        branch: 'Branch/facility',
        authority: 'Authority',
        resend_verification_email: 'Resend verification email',
        password_settings_status: 'Password Setting Status',
        status: {
          configured: 'Configured',
          not_configured: 'Not set up',
        },
      },
      place_holder: {
        filter_name: 'Please enter the filter name',
        first_name: 'Tanaka',
        last_name: 'Tarou',
        first_name_kana: 'タナカ',
        last_name_kana: 'タロウ',
        select_company: 'Select an organization',
        select_country: 'Select country',
        select_branch: 'Select branch',
        email: 'New email address',
        password: 'Password',
      },
      reinvite: 'Reinvite',
      notify: 'We have resend the reset URL to the registered email address.',
      no_item_search: 'There are no results that match your search.',
      enter_8_digits:
        '※Enter 8 or more digits by mixing alphanumeric characters',
      affiliation_infomation: 'Affiliation information',
      sur_name: 'Last name',
      name: 'First name',
      sur_name_kana: 'Last name (katakana)',
      name_kana: 'First name (katakana)',
      back_to_top: 'Return to TOP of users management',
      change_mail_modal: {
        title: 'Do you want to change your email?',
        sub_title:
          'After changing your email address, you cannot change it again for the next 30 days.\nPlease make sure your email address is correct.',

        email: 'New Email Address',
        password: 'Please enter your password for verification',
        info: 'A confirmation email will be sent to the new email address after the change.',
        error: {
          email_exist: 'This email is already in use',
          password_incorrect: 'The password is incorrect',
          change_email:
            'You cannot change your email address until {{time}} on {{date}}.',
          prevent_new_request:
            'You recently made a request to change your email address. You cannot make a new change request within 24 hours of the previous request.',
        },
      },
    },
  },
  contact: {
    inquiry_form: 'Inquiry Form',
    require: 'Required',
    company_name: 'Organization Name',
    fullName: 'Full Name',
    plCompanyName: 'Stock organization Tanso',
    plFirstName: 'Yamada',
    plLastName: 'Touru',
    plBranch: 'Tokyo Branch/Shibuya Branch',
    plDepartment: 'CSR Department',
    plJobTitle: 'Manager',
    plOthers:
      'Please enter the details of the premium features you would like to use. (Example) Please tell me more about the features and pricing plans. I would like to know about the consortium function. etc.',
    privacy_policy_text_link:
      'By submitting this form, you agree to <1>tansomanGX’s Privacy Policy<1>',
    privacy_policy_text:
      ', and consent to receive TansoCheck marketing communications.',
    facility: 'Branch/Facility',
    department: 'Department',
    jobTitle: 'Job Title',
    phone: 'Phone Number',
    subPhone: '*If you work from home, please enter your cell phone number.',
    plPhone: '08012345678',
    email: 'Email Address',
    area: 'Premium features to use',
    other_requires: 'Other requirements',
    note_other: 'Please enter your inquiry details.',
    plArea:
      'Please fill in the content of your inquiry. For example, “Please tell me more about the features and price plans” or “I would like to know about the report function”, etc.',
    tansoCheck: {
      full: 'By submitting this form, you agree to TansoCheck’s Privacy Policy, and consent to receive TansoCheck marketing communications.',
      first: 'By submitting this form, you agree to',
      second: 'TansoCheck’s Privacy Policy',
      third: ', and consent to receive TansoCheck marketing communications.',
    },
    send: 'SEND',
    send_success:
      'Your inquiry has been sent successfully! We have sent you an automatic rply email, please check that you have received it.',
    send_success_title: 'We have received your inquiry',
    send_success_content:
      'Please note that an automatic reply confirmation email will be sent to the email address you entered.',
    send_failure_title: 'Failed to send your inquiry',
    send_failure_content:
      'Please return to the previous screen.\nCheck the contents, and press the "Send" button again.',
  },
  upload: {
    do_you_want_to_delete:
      'Are you sure you want to delete the selected input data?',
    cancel: 'CANCEL',
    download_template: 'Download Template：',
    registration: {
      from_image: 'NEW REGISTRATION FROM IMAGE',
      by_manual: 'NEW REGISTRATION BY MANUAL',
      scope: 'Scope',
      all: 'All',
      category: 'Category',
      key_word: 'Free Text Search',
      key_word_placeholder: 'Free Text Search',
      filtering: 'Filtering ー {{ status }}',
      emission_category: "Carbon's scope",
      detail_information: 'Emission registration',
      upload_image: 'Upload image (*Please use it to manage invoice data.)',
      full_title: 'Facility information',
      require: 'Required',
      scope2_factor: 'Electricity is SCOPE 2’s factor.',
      returnToTop: 'Return to Register Emissions Top',
      return: 'Return',
      status: 'Status',
      registration_date: 'Registration Date',
      select_date: 'Select Date',
      select_date_sp: 'YYYY/MM/DD',
      year_of_month: 'Year & Month of Use',
      year_of_month_sp: 'YYYY/MM',
      select_year_and_month: 'Select year and month',
      select_year_and_month_sp: 'YYYY/MM',
      clear: 'Clear Filters',
      apply: 'APPLY',
      search: 'Search',
      download: 'CSV DOWNLOAD',
      delete: 'DELETE CHECKED DATA',
      edit_registration: 'EDIT REGISTRATION DATA',
      go_to_company_shared: 'Share your own emissions',
      target_organization: 'Target organization',
      additional_information: 'Additional Information',
      attachment: 'Attachment',
      image_upload: 'Image List',
      manual_input: 'Input List',
      about_us: 'Organization Information',
      label: {
        company_name: 'Organization Name',
        facility: 'Branch/Facility',
      },
      note: 'If you do not have an option, please register your base <style>here</style>.',
      placeholder: {
        emissionName: `Electricity of 4F, President's car, etc.`,
        supplier: '〇〇 Organization、〇〇 Electric organization, etc.',
      },
      description:
        'You can register the emissions data used by your organization.',
      button: {
        to_list_registration: 'Emissions registration',
      },
      choose_file_upload: 'Choose upload',
      upload_excel_tab: 'インポート',
      history_upload_excel_tab: 'インポート履歴',
      history_upload_created: 'アップロード日',
      history_upload_dowload_csv: 'ファイル名',
      history_upload_name: 'スコープ',
      history_upload_total: '登録件数',
      history_upload_user: '登録ユーザー',
      history_upload_action: '登録されたデータ',
      show_data_upload: 'データを確認する',
    },
    table: {
      controlName: 'Control name',
      name: 'Name',
      companyName: 'Organization Name',
      facility: 'Branch/Facility',
      registerUser: 'Registration User',
      registerDate: 'Registration Date',
      year_of_month: 'Year & Month of Use',
      scope: 'Scope',
      category: 'Category',
      classification: 'Classification',
      item: 'Item',
      type_of_ess: 'Type of emissions intensity',
      data_source: 'Data source',
      supplier: 'Supplier',
      amount: 'Amount',
      paid_amount: 'Paid amount (Yen)',
      unit: 'Unit',
      co2: 'CO2 Emission (tCO2e)',
      co2_market: 'CO2 Emission (tCO2e) market',
      co2_location: 'CO2 Emission (tCO2e) location',
      attachment: 'Bulk registration Excel file',
      menu: 'Menu',
      scopes: {
        all: 'All',
        scope_1: '1 Direct emissions',
        scope_2: '2 Indirect emissions',
        scope_3: '3 Other indirect emissions',
      },
      status: {
        status: 'Status',
        faild: 'Failed',
        complete: 'Complete',
        inprogress: 'In-progress',
        incomplete: 'Incomplete',
      },
      ghg: 'GHG',
      no_row_selected: 'No items selected',
      emission_factor_main: 'Emission factor',
      item_scope2: 'Electric utility/item',
      emission_scope2: 'Menu/emission factor',
    },
    button: {
      delete: 'Delete',
      cancel: 'Cancel',
      update: 'Update',
      register_emissions: 'Register Emissions',
      csv_upload: 'Bulk registration',
      invoice_ocr: 'From invoices (AI)',
      display_options: 'Display Options ({{selected}}/{{total}})',
      submit_checkbox: 'Filter items',
      select_all: 'Select all',
      deselect_all: 'Deselect all',
    },
    classification: {
      ethylene_production: 'Ethylene production',
      use_of_acetylene: 'Use of acetylene from calcium carbide',
      fuel_use: 'Fuel use',
      electricity: 'Electricity',
    },
    items: {
      production_of_ethylene: 'Production of ethylene',
      use_of_acetylene: 'Use of acetylene from calcium carbide',
      raw_coal: 'Raw coal',
      common_coal: 'Common coal',
      coke: 'Coke',
      coal_tar: 'Coal tar',
      gasoline: 'Gasoline',
      smokeless_coal: 'Smokeless coal',
      petroleum_coke: 'Petroleum coke',
      petroleum_asphalt: 'Petroleum asphalt',
      electricity_2022: 'Electricity (2022)',
      electricity: 'Electricity',
    },
    types_of_emission_intensity: {
      production_of_ethylene: 'エチレンの製造',
      use_of_acetylene: 'カルシウムカーバイドを原料としたアセチレンの使用',
      raw_coal: '原料炭',
      common_coal: '一般炭',
      coke: 'コークス',
      coal_tar: 'コールタール',
      gasoline: 'ガソリン(L)',
      smokeless_coal: '無煙炭',
      petroleum_coke: '石油コークス',
      petroleum_asphalt: '石油アスファルト',
      electricity_2022: '原料炭',
      electricity: {
        electricity_1: '北海道電力(株)_メニューB（残差）',
        electricity_2: '東京電力エナジーパートナー(株)_メニューG（残差）',
        electricity_3: '北陸電力(株)_メニューC（残差）',
        electricity_4: '中部電力ミライズ(株)_(参考値)事業者全体',
      },
    },
    label: {
      display_options: 'Display Options',
    },
    description: {
      scope_1:
        'Direct greenhouse gas emissions from facilities owned or managed by the organization. Mainly includes emissions from fuel combustion and factory/vehicle emissions.',
      scope_2:
        'Indirect greenhouse gas emissions from energy use such as electricity, steam, heat, and air conditioning purchased from external sources. Emissions occur on the side of the energy supplier.',
      scope_3:
        'Other indirect emissions occurring throughout the value chain, including raw material procurement, product use/disposal, employee commuting, and logistics.',
    },
  },
  emissions_detail: {
    view_emission_intensity: 'View Emission Intensity',
    scope: 'Scope',
    classification: 'Classification',
    item: 'Item',
    type_of_emission_intensity: 'Type of emissions intensity',
    input_unit: 'Input unit',
    emission_factor_main: 'Emission factor',
    emission_factor_s1: 'Emission Factor (secondary1)',
    emission_factor_s2: 'Emission Factor (secondary2)',
    primary_data: 'Primary Data',
    updated_date: 'Updated Date',
    supplement: 'Supplement',
    valid_period: 'Valid period',
    primary_data_collected:
      'Primary Data: Data collected from suppliers, etc. under the responsibility of the calculator.',
    cancel: 'CANCEL',
  },
  emission_intensity: {
    clear: 'CLEAR',
    apply: 'APPLY',
    scope: 'Scope',
    delete: 'Delete',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    scope1_select: '1 Direct emissions',
    scope2_select: '2 Indirect emissions ',
    scope3_select: '3 Other indirect emissions',
    no_data: 'There are no results that match your search.',
    category: 'Category',
    target_year: 'Fiscal year',
    scope_1: 'SCOPE 1',
    scope_2: 'SCOPE 2',
    scope_3: 'SCOPE 3',
    tooltip: {
      scope_1:
        'Scope 1 refers to greenhouse gas emissions directly emitted from in-house fuel use and industrial processes.',
      scope_2:
        "Scope 2 is the amount of indirect greenhouse gas emissions caused by an organization's use of electricity, heat, and steam supplied by other companies.",
      scope_3:
        "Scope 3 refers to the amount of greenhouse gases emitted during the process from procuring raw materials to manufacturing, sales, consumption, and disposal (supply chain emissions). ''Other indirect emissions'' other than Scope 2 (indirect emissions from the organization).",
    },
    total: 'Total',
    records: 'records',
    create_coefficients: 'Create coefficients',
    table: {
      year: 'Fiscal Year',
      class_ification: 'Classification',
      item: 'Item',
      type_of_emissions_intensity: 'Type of emissions intensity',
      datasource: 'Data source',
      category: 'Category',
      input_unit: 'Input unit',
      emission_factor_main: 'Emission factor main',
      emission_factor_market: 'Emission factor market',
      emission_factor_location: 'Emission factor location',
      emission_factor_main_unit: 'Emission factor_unit',
      emission_factor_secondary: 'Emission factor (secondary)',
      emission_factor_secondary_unit: 'Emission factor (secondary)_unit',
      primary_data: 'Primary Data',
      update_date: 'Update Date',
      ghg: 'GHG',
      emission_factor_location_amount: 'Emission factor location amount',
    },
    create_coefficients_scope3: 'SCOPE{{number}}’s coefficient CREATION',
    edit_coefficients_scope3: 'SCOPE3’s coefficient EDIT',
    classification: 'Classification',
    item: 'Item',
    type_of_emissions_intensity: 'Type of emissions intensity',
    input_unit: 'Input unit',
    emission_factor: 'Emission Factor',
    datasource: 'Datasource',
    note: 'Note',
    valid_period: 'Valid period',
    select_date: 'Select Date',
    select_or_enter_to_create_new: 'Select or enter to create new',
    limit_number_decimal: 'Up to 10 digits of integer or 20 digits of decimal.',
    note_type_of_emission_intensity_1: 'Example: A fuel oil, kerosene',
    note_type_of_emission_intensity_2:
      'Example: Low-voltage power, high-voltage power, eco plan',
    note_type_of_emission_intensity_3:
      'Example: Purchased products, company transport vehicles, waste disposal, business trips, commuting',
    description:
      'You can check the emission coefficient data registered in Tanso Check. You can also register your own coefficient data according to your needs.',
    button: {
      to_emission_list: 'View emission intensity list',
    },
    placeholder: {
      source: 'Please enter a source name that is easy to manage.',
    },
    in_use: 'in use',
    of_company: 'of company',
    emission_type: 'emission type',
    emission_version_title: 'Ministry of the Environment ver3.4',
    emission_version_description:
      'These are the coefficients officially announced by the Ministry of the Environment. We refer to the latest <1>ver3.4</1>.',
    emission_unit_title:
      'Ministry of the Environment (reference to Nm3 figures)',
    emission_unit_description:
      'These are reporting coefficients created based on the coefficients announced by the Ministry of the Environment. The background to the creation of these coefficients is that the units announced by the Ministry of the Environment alone are not sufficient for reporting, so we have created them to match the units that users normally use. We use the Nm3 coefficient for city gas to create the m3 coefficient.',
    emission_shiping_title:
      'Regarding the coefficients for Category 1 that include transportation costs',
    emission_shiping_description:
      'Among the coefficients for environmental load units that take into account the global supply chain, we omit those that do not include the emission coefficient. ',
    emission_propane_title: 'Propane/Butane (volume basis)',
    emission_propane_description:
      'These coefficients are calculated based on the ratio of general LP gas. Based on the coefficients of the Ministry of the Environment, they are created assuming production with 70% propane and 30% butane.',
    emission_policy_description:
      'This explains the source of the emission intensity coefficients provided by Tansocheck.',
    emission_policy_btn: 'Go to Emission Intensity Policy',
  },
  manual_input: {
    register_btn: 'Register consecutively',
    register_one_time_btn: 'Register',
    bulk_upload: 'BULK UPLOAD',
    add_one_line: '+ 1 LINE ADDED',
    add_ten_line: '+ 10 LINES ADDED',
    delete: 'DELETE',
    check_line: 'CHECKED LINE COPY AND ADD CHECKED LINE',
    name: 'Name',
    suppliers: 'Supplier',
    emission_factor: 'Emission factor',
    emission_factor_location: 'Emission factor location',
    emission_factor_market: 'Emission factor market',
    emissions_co2: 'CO2 emission (tCO2e)',
    year_month_of_use: 'Year & Month of Use',
    select_year_and_month: 'Select year and month',
    classification: 'Classification*',
    menu: 'Menu*',
    item: 'Item*',
    type_of_emissions: 'Types of Emission Intensity',
    activity: 'Activity*',
    value: 'Value',
    unit: 'Unit',
    paid_amount: 'Paid amount',
    factor_main_unit: 'Factor Main Unit',
    please_fill: 'Please fill in the required fields.',
    register: 'REGISTER',
    tooltip: {
      scope:
        'Scope refers to the range within which greenhouse gas emissions are measured.',
      name: 'Quantity and monetary data of products or services purchased or acquired by the organization',
      supplier:
        'Emissions from the resource extraction stage to the manufacturing stage related to products or services purchased or acquired by the organization by supplier name',
      classification: 'Classification of fuel used',
      ghg: 'The GHG (Greenhouse Gas) Protocol is an international standard for calculating and reporting greenhouse gas emissions.By reporting in accordance with this standard, companies can ensure reliable information disclosure. Scope 1 to Scope 3 are set up, and the feature is that emissions are based on the emissions of the entire supply chain, from raw material procurement to consumption and disposal.',
    },
    title_copy: 'Copy',
    register_user: 'Register User',
    updated_user: 'Updated User',
    emission_amount_market: 'CO2 Emissions - Market Factor',
    emission_amount_location: 'CO2 Emissions - Location Factor',
    emission_name: 'Emission Factor',
  },
  csv_input: {
    title_page: 'Bulk registration',
    csv_upload: 'Upload',
    button_upload: 'Register',
    button_remove: 'Cancel Upload',
    uploaded: 'has been uploaded.',
    note_1: '※Is the file being uploaded in Excel format?',
    note_2:
      '※Are the classification, item, type of emission factor, GHG, emission coefficient, and unit accurate?',
    note_3:
      '※Please refer to the <1>emission intensity screen</1> or the <2>bulk registration template</2> when entering the data.',
    errors: {
      invalid_type: 'Contains unsupported file extensions.',
      upload_success: 'File has been uploaded.',
      branch_not_found: {
        title: 'Branch Information Not Found',
        description:
          'The branch information selected in the bulk registration screen after this CSV has been deleted, not within the CSV file. Please re-upload the CSV file after configuring it again.',
      },
      file_empty: {
        title: 'An empty file has been uploaded.',
        description: 'Please verify and re-upload a file containing data.',
      },
      table_error: {
        title: 'There are empty cells',
        description:
          'The cells for required items in the following rows are empty. Please fill them in and upload again.',
      },
      error_empty_cell: {
        title: 'There are empty cells',
        description:
          'The cells for required items in the following rows are empty. Please fill them in correctly and upload again.',
      },
      error_format: {
        title: 'There are cells with incorrect formats.',
        description:
          "The format for 'Date of Use' should be 'yyyy/mm'.\n'Emission Coefficient', 'Activity Level', and 'Billing Amount' should be in half-width numbers.\nPlease enter the correct format for 'Emission Coefficient', 'Date of Use', 'Activity Level', or 'Billing Amount'.",
      },
      error_branch_items: {
        title: 'Enter your registered electricity organization',
        description:
          'Please enter from among the registered electric power organizations.',
      },
      error_emission_not_found: {
        title: 'Please input the correct type of emission source unit',
        description:
          "Please input the emission source unit from the list on the 'Emission Source Units' page",
      },
      excel_template: 'Template not found',
      usage_date_not_valid: '正しい日付を選択してください。',
      classification_not_valid: 'この分類は存在しません。',
      item_not_valid: 'この品目は存在しません。',
      emission_not_valid: 'この単位は存在しません。',
      amount_not_valid: '半角数字を入力してください。',
      branch_not_valid: 'この施設／拠点が存在しません。',
      unit_not_valid: 'この単位は存在しません。',
      company_electric_not_exist: '電力会社が見つかりませんでした。',
      category_not_valid: 'カテゴリーは存在しません',
    },
    type_errors: {
      name: 'name',
      year: 'Year & Month of Use',
      class: 'classification',
      item: 'item',
      emission_intensity: 'type of emission intensity',
      ghg: 'GHG',
      emission_factor: 'emission factor',
      amount: 'activity amount',
      unit: 'unit',
      cost: 'activity cost',
      currency: 'currency',
    },
    modal: {
      upload_error: {
        title: 'Please correct the errors in the EXCEL file.',
        button_confirm: 'Upload again',
      },
      error_unknown: {
        title: 'The operation failed due to an unknown error.',
        description:
          'I apologize for the inconvenience. Please contact us via email by clicking the button below.\nAlternatively, you can also reach out to us using the button at the bottom right of the screen.',
        button_confirm: 'Inquiry',
      },
    },
  },
  image_upload: {
    file_here: 'File here',
    drop_and_upload: 'Drop and upload',
    or: 'Or',
    select_file: 'Select Files',
    select_data_file: 'Select file',
    multi_file:
      'Up to 5 files can be attached per record. Valid types are <1>JPEG・PNG・JPG・JFIF・HEIC・PDF</1>. One file is limited to 10 MB. \nUpload your documents as well to help properly manage your input data!',
    multi_file_sp:
      'Up to 5 files can be attached per record.\n Valid types are <1>JPEG・PNG・JPG・JFIF・HEIC・PDF</1>.\n One file is limited to 10 MB. Upload your documents as well to help properly manage your input data!',
    valid_type_are: 'Valid types are ',
    limit_file: 'One file is limited to 10 MB.',
    note: 'NOTE',
    for_AI_upload:
      'For AI Upload, 1 activity data is registered for 1 image/file.',
    use_bulk_reading: 'Use [BULK READING] in ',
    manual_input: 'Manual input ',
    to_register_multiple_data: 'to register multiple data by CSV.',
    cancel: 'CANCEL',
    submit: 'SUBMIT',
    format: '',
  },
  change_password: {
    current_password: 'Current Password',
    new_password: 'New Password',
    confirm_password: 'Confirm New Password',
    change: 'Change Password',
    change_password: 'Change Password',
    password_not_match: 'Password does not match.',
  },
  payment: {
    change_usage_plan: 'Change Usage plan',
    starter_plan: 'Starter plan',
    free: 'Free',
    co2_emission_automatic: 'CO2 emission automatic calculation',
    current_plan: 'Current plan',
    premium_plan: 'Premium plan',
    automatic_registration:
      'Automatic CO2 emissions calculation function for SCOPE3',
    monthly_charge: 'MONTHLY CHARGE\n',
    yen_month: '/MONTH',
    upgrage: 'Upgrade',
    to_see_up_to: 'To see up to',
    scope3: 'SCOPE3',
    and_use_automatic:
      'and use automatic calculation function by AI, please click here!',
    downgrage: 'Downgrade',
    downgraged: 'Downgraded',
    confirming: 'Confirming',
    success: 'Success',
    error: 'Error',
    failure: 'Failure',
    admin_upgrage: 'Please contact the\n administrator to downgrade',
    table: {
      payment_histoty: 'Payment History',
      No: 'No',
      date: 'Date',
      amount: 'Amount',
      currency: 'Currency',
      status: 'Status',
      note: 'Note',
      error_stripe: 'Error detail',
    },
    bill_detail: 'Billing detail',
    currency: 'Currency',
    usd: 'USD',
    jpy: 'JPY',
    credit_debit_card: 'Credit /Debit Card',
    subscribe: 'Subscribe',
    upgrade_successful: 'Upgrade successful.',
    take_advantage: 'Take advantage of the premium plan features!',
    ok: 'OK',
    upgrade_failed: 'Upgrade failed.',
    please_check_the_error: 'Please check the error and try again.',
    error_detail: '(ERROR DETAIL)',
    do_you_want_to_downgrade:
      'About downgrading from Premium Plan to Free Plan',
    cancel: 'CANCEL',
    premium_plan_features_will: `Thank you for using the Premium plan feature of Tanso Check. Please check the notes regarding downgrading below before proceeding.
    ・Even if you downgrade, you cannot get a refund. However, you can use the Premium plan until the next scheduled payment date.
    ・After the next scheduled payment date, you will not be able to view all Premium features.
    ・Even if you upgrade again after downgrading, you may not be able to use the data which been created by the previous Premium plan. So please be careful when downgrading.
    ・In order to stop the next renewal, it is necessary to request the downgrade 10 days before the expiration date. So please note that `,
    premium_downgrade_last:
      'if you request in the last 10 days of the current usage period, you will be charged for the next month before turning back to the Free plan.',
    plan_info: {
      free: {
        tag: 'For first-time users',
        title: 'Start plan',
      },
      premium: {
        tag: 'For professionals',
        title: 'Premium plan',
      },
      price: '<style>{{price}}</style> JPY/Month',
      co2_emission_automatic: 'CO2 emission automatic calculation',
      analysis_function: 'Analysis function',
      report_function: 'Report function',
      user_management: 'User management',
      scope_1_2_measure: 'Scope 1,2 Measure',
      scope_3_measure: 'Scope 3 Measure',
      document_management: 'Document management',
      report_creation: 'Report creation',
      grant_authority: 'Grant authority',
      co2_reduction: 'CO2 reduction',
      note: '※If you want SCOPE 3, you need to change to a premium plan. Please contact us if you would like to make changes by bank transfer.',
    },
  },
  message_error_stripe: {
    card_declined: 'The card has been declined.',
    common: 'An unknown error has occurred',
    require: 'Please enter your card information correctly',
    payment_outside: 'Payment outside, admin changed plan.',
  },
  error: {
    email_request_error:
      'Token has expired. Please login and create another email change request.',
    not_found_404: '404 Not Found',
    not_premium:
      'This feature is not available for contracted plans. \n Please contact us to change contracted plan.',
    something_wrong: 'Sorry, something went wrong!',
    user_not_premium: 'User is not premium',
    permission_denied: 'Permission denied',
    user_inactive: 'User is inactive',
    unauthorized: 'Unauthorized',
    network: 'Network Error',
    something_error_with_reload:
      'An error occurred. Please reload the page and try again.',
    ip_blocked:
      'Access from this IP address is not allowed.\nPlease login from an allowed IP address.',
    delete_branch_has_users:
      'Cannot delete the branch because users are registered to it.',
    branch_not_found:
      'The selected facility was not found. Please select it again.',
    branch_item_not_found:
      'The selected item is not registered to this facility. Please check the facility settings or select another item.',
  },
  my_account: {
    page_title: 'Account',
    user_information: 'User information',
    edit_button: 'Edit information',
    back_to_top: 'Turn to Account Top',
  },
  tutorial: {
    title: 'You can check it anytime',
    description:
      'If you do not know how to use it or want to know more details,\n「Account > <to>Tutorial</to>」\navailable at any time.',
  },
  authority: {
    parent_user: 'Parent user',
    manager: 'Management',
    viewer: 'Viewer',
    facility_management: 'Facility management',
    facility_viewer: 'Viewer',
    data_registration: 'Data registration',
    description: {
      parent_user: 'Can view, edit, and add users across all screens.',
      manager: 'Can view, edit, and add users across all screens.',
      viewer: 'The assigned user can only view content.',
      data_registration:
        'Only emissions data can be registered. A given user can only view and edit their own registered data.',
      facility_management:
        'The assigned user can register, view, edit, and delete data related to the affiliated location. *Adding new locations is not allowed. Adding other users is only possible for the same location.',
      facility_viewer:
        'The assigned user can only view data related to the location they are affiliated with.',
    },
  },
  subsidy: {
    title: 'File Management',
    add_folder: 'Folder',
    upload_file: 'Upload a file',
    table: {
      name: 'Name',
      lastModified: 'Last modified date',
    },
    modal: {
      create_title: 'New folder',
      rename_title: 'Rename',
      placeholder: '2023 SHIFT project',
      add: 'Create',
      rename: 'OK',
      cancel: 'Cancel',
      loading: 'Please wait...',
      upload_success: 'Upload has been completed',
      folder_name_hint: '',
      error: {
        folder_name_empty: 'Please enter the folder name.',
        file_name_empty: 'Please enter the file name.',
      },
      confirmation: {
        heading: 'The file name is the same',
        sub_heading:
          'Please choose whether to overwrite the existing file or upload as a new file.',
        options: {
          overwrite: 'Overwrite the existing file',
          upload_new: 'Upload as a new file',
        },
      },
    },
    option: {
      download: 'Download',
      edit_name: 'Rename',
      preview: 'Preview',
      move_to_trash: 'Move to trash',
    },
  },
  formatFileName: '"{{fileName}}"',
  file_management: {
    garbage: {
      title: 'Trash',
      announcement:
        'Items in the trash will be permanently deleted after 30 days.',
      empty_trash: 'Empty the trash',
      name: 'Name',
      deletionDate: 'Deletion Date',
      restoration: 'Restore',
      delete_forever: 'Permanently delete',
      show_file_location: 'Show file location',
      delete_permanently_title: 'Delete completely?',
      delete_permanently_content:
        ' will be deleted forever and you won’t be able to restore it.',
      empty_trash_content:
        'Permanently delete all items in the trash. Cannot be restored after deletion.',
      returnToTop: 'Return to file management',
      empty_trash_failed_message_title: 'Delete failed',
      empty_trash_failed_message_content:
        'Deleting all items in the trash has failed. Please try again later.',
    },
    message: {
      move_to_trash_success: 'Moved to trash.',
      no_trash: 'There is no data.',
      empty_trash_success:
        'All items in the trash have been permanently deleted.',
    },
  },
  setting_password: {
    title: 'Password setting',
    confirm_password: 'Password confirmation',
    placeholder: {
      please_input_password: 'Please enter your password',
    },
  },
  company: {
    general_title: 'Organization settings',
    own_company_setting: 'Organization information settings',
    group_management: 'Group management',
    own_company_setting_description:
      'You can edit organization information, register locations, and grant editing permissions to members.',
    group_management_description:
      'You can group and manage the organizations you manage. Manage each organization as a consortium to help analyze emissions data.',
    about_us: 'Organization Information',
    code: 'Organization code',
    tab_facility: 'Base settings',
    tab_user: 'User settings',
    company_group: 'Group name',
    invitation_status: 'Invitation status',
    button: {
      to_own_company_setting: 'Organization information',
      to_group_management: 'Group management',
      own_company_setting: 'Setting',
      search: 'Search',
    },
    invite_status: {
      current_company: 'In-house',
      approved: 'Coordinated',
      pending: 'Pending',
    },
    collaboration_shared: {
      in_integration: 'Coordinated',
      not_integrated: 'Pending',
    },
    invite_screen_title: 'Collaborate with other companies',
    invite_screen_description:
      'Collaborate with organizations already registered with Tansocheck',
    invite_screen_note:
      '*If you want to collaborate with an organization that is not registered with Tansocheck, please send an invitation by clicking <style>Send a Tanso Check invitation</style>.',
    company_name_auto: 'Organization Name (Auto-fill)',
    company_requested_modal_title: 'Request organization collaboration',
    company_requested_modal_description:
      'Is there a problem with the content being sent? Do you want to send it?',
    invite_screen_send_invitation: 'Send invitation to Tansocheck',
    company_modal_send_invitation_title: `Send an invitation to Tansocheck to collaborate with your organization`,
    company_modal_send_invitation_subject:
      'Invite other companies to Tanso Check and share their Co2 emissions. Send an invitation via email by "Copy text".',
    company_modal_send_invitation_body: `You have received an invitation from {{companyName}} to join Tansocheck, which allows you to visualize your CO2 and other emissions.
Collaborate with {{companyName}} to share and manage your emissions.
After registering as a member at the URL below, send an invitation to collaborate with {{companyName}}.

Register here: {{registerUrl}}
*If you register at this URL, you will receive an invitation to collaborate from {{companyName}} within the Tansocheck service.`,
    company_modal_send_invitation_subject_auto:
      'You have received an invitation from Organization Settings to join TanSoCheck.',
    copy_text: 'Copy text',
    company_modal_send_invitation_copy: 'I copied the text.',
    company_modal_send_invitation_open_email: 'Open email',
    company_modal_copy_success: 'Open email',
    company_shared_title: 'Share your emissions',
    company_shared_status: 'Sharing your own emissions data',
    calculation_basis: {
      revenue: 'Revenue',
      volume: 'Volume',
    },
    company_shared_group: 'Group name',
    company_shared_modal_title: 'Link your own emissions data',
    company_shared_modal_content:
      "Share your organization's emissions data with {{companyName}}",
    company_button_accept_shared: 'Link emissions data',
    company_button_shared: 'On',
    company_button_not_shared: 'Off',
    analysis_button: 'Analysis',
    register_data_button: 'Emissions list',
    edit: {
      placeholder: 'Enter your organization name',
    },
    label: {
      created_at: 'Request date and time',
      emission_amount: 'Supplier-related emissions (tCO2e)',
      calculation: 'Calculation basis',
      status_share: {
        requested: 'Requested',
        shared: 'Shared',
        stop: 'Stop',
      },
      request_share_title: 'Request share emission data',
      placeholder: {
        company_name: 'Organization Name',
        branch: 'Select a Branch/Facility',
      },
      description_total_emission_amount:
        'Emissions related to business partners refer to the amount of emissions from the total emissions that are only related to the linked companies.\nReference calculation formula: Emissions × Shipment amount / Total sales',
    },
    fiscal_year_start_month: 'Financial year start month',
  },
  facility: {
    base_name: 'Facility name',
    country_name: 'Country',
    electric_companies: 'Electric Power Organization',
    status: 'Status',
    form: {
      label: {
        base_name: 'Branch/Facility',
      },
      note: '*You can edit it, but you cannot delete it. If you want to delete it, please contact us <style>here</style>.',
    },
    more: '(More...)',
    message: {
      copy_success: 'The copy was successful.',
      copy_fail: 'The copy failed.',
      pin_success: 'Pinned successfully!',
      unpin_success: 'Unpinned successfully!',
      pin_fail: 'Pin failed!',
      unpin_fail: 'Unpin failed!',
    },
  },
  registration: {
    tab: {
      own_company: 'Organization',
      other_companies: 'Outside the organization',
    },
    scope2: {
      empty_data_power_companies_message:
        'First, please register your power organization in the base settings',
      group_label: {
        branch_power_companies:
          'Electricity organizations registered at the base',
        remaining: 'All',
      },
    },
  },
  notification: {
    button: {
      go_to_analysis: 'Go to analysis',
      go_to_data: "Go to other companies' emissions list",
      share_emissions: 'Share emissions',
      go_to_notification: 'Go to notification',
      go_to_detail_company: 'Go to list of organization emissions',
      go_to_shared_screen: 'Go to shared screen',
    },
    received_request: {
      title: 'We have received a request for organizational collaboration.',
      description: 'Please check the notifications',
    },
    modal: {
      title: 'We have received a request for organizational collaboration.',
      description: 'Press "Approve" to start the linkage',
    },
    request: {
      title:
        'We have received an organizational linkage request from {{companyName}}.',
      description:
        'We have received a request for organizational collaboration from {{companyName}}. Click the button below to approve and share your emissions.',
    },
    approved: {
      title:
        'Organizational integration with {{companyName}} has been completed.',
      description:
        'Your organizational collaboration with {{companyName}} has been completed. Share your emissions with {{companyName}} below.',
    },
    shared: {
      title: 'Co2 emissions data was shared by [{{companyName}}]',
      description:
        'Co2 emissions data has been linked from {{companyName}}. Use the button below to view and analyze the C02 emissions data of {{companyName}}.',
    },
    request_share: {
      title:
        'We have received a request to share emissions data from [{{companyName}}].',
      description: 'Year: {{year}}\nScope: {{scope}}',
    },
    update_share: {
      title: '[{{companyName}}] Emissions data has been updated',
      sub_title: 'Detailed data is as below:',
      before: 'Change before: ',
      after: 'After change: ',
    },
  },
  group_management: {
    title: 'Group management',
    not_affiliation: 'Not affiliation',
    button: {
      edit_group: 'Edit',
      create_group: 'Add new group',
      add_company: 'Add an organization',
    },
    modal: {
      create: {
        title: 'Add new group',
        select_group: 'Parent group',
        input_name: 'Group name',
        confirm: 'Add',
      },
      edit: {
        title: 'Edit group name',
        input_name: 'Group name',
      },
      remove_group: {
        title: 'Confirmation',
        description: 'Are you sure you want to delete the group?',
      },
      remove_company: {
        title: 'Confirmation',
        description: 'The organization will be deleted. Are you sure?',
      },
      placeholder: {
        group_name: 'ABC City, △△△ Division, DFC Area, 〇〇 Factory',
      },
    },
    group: {
      title: 'Group list',
      empty_data: 'There are no groups.',
      selected_location: 'Selected location',
    },
    select: {
      title: 'List of organizations in "{{position}}"（{{count}}）',
      empty_data: 'There are no organizations in this group.',
      placeholder: 'Select an organization',
    },
    message: {
      create_group_success: 'Group has been created successfully.',
      name_group_exist: 'Group name already exists.',
      remove_group_success: 'Group has been deleted successfully.',
      remove_company_success: 'The organization has been deleted',
      edit_group_success: 'Edit group name successfully',
    },
  },
  title: {
    request_premium_form: 'Usage plan change request form',
    other_company_data: "Other organization's emission",
  },
  button: {
    to_request_management: 'To the list of partner companies',
    to_shared_emissions: 'To manage collaboration status',
    add_new_invite: 'Invite organization',
    add_new_request_share: 'Add request',
    confirm: 'Confirm',
    filter: 'Filter',
    set_base_year: 'Set Base Year',
    save: 'Save',
    to_setting_screen: 'To setting screen',
    analyzing_total_emissions: 'Analyzing total emissions',
    scope_analysis: 'Analyze scope {{number}}',
    other_analysis: 'Further analysis',
    report_analysis: 'To the report page',
    external_emission_data: 'External emissions data',
  },
  share_management: {
    title: 'Collaboration status management',
    tab: {
      share_request: 'Request list',
      share_emission: 'Share management list',
    },
    placeholder: {
      year: 'Please select year',
    },
    shared_management_title: 'Shared management',
    request_management_title: 'List of Partner Companies',
    request_management_description:
      'You can check the request status of companies you have requested in the past and add new partners.',
    shared_emissions_title: 'Collaboration status management',
    shared_emissions_description:
      'You can check the companies you are collaborating with and the sharing status. You can also check the data sharing status and the individual emission numbers.',
  },
  usage_plan: {
    title: 'Change plan',
    sub_title:
      'Please contact us via the following page with the plan you would like to use.',
    info: {
      tag: {
        standard: 'Standard',
        premium: 'Premium',
        using: 'Using',
      },
      standard: {
        price: 'Standard',
        description:
          '*With this plan, you can use the following features for free.',
      },
      premium: {
        price: 'Premium Fee',
        description:
          '*Prices are based on the purpose and scale of use of the organization. For details, please contact us from "Use".',
      },
    },
    feature: {
      scope_1_3: 'Scope1-3 compatible',
      co2_automatic_calculation: 'Automatic calculation of CO2 emissions',
      analysis: 'Analysis function',
      report: 'Report function',
      staff_account: 'Add account staff function',
      document_management: 'Document management function',
      consortium: 'Consortium function (data link function of other companies)',
      csv_export: 'CSV Export',
      target: 'Target',
    },
    button: {
      use: 'Use',
    },
  },
  goal: {
    title: {
      reduction_normal_create: 'Unique reduction measure registration screen',
      reduction_filter_create: 'Reduction measures registration screen',
      version_list: 'Reduction Value Setting',
      table_version_list: 'Target Setting',
      reduction_plans_for_each_scope: 'Reduction forecast image',
      version_detail: 'Create target management',
      version_edit: 'Edit target management',
    },
    label: {
      scope: 'Scope',
      version: 'Version',
      unique_reduction_measures: 'Unique reduction measures',
      reduction_measures: 'Reduction measures target',
      reduction_measures_detail: 'Reduction measures detail',
      reduction_measures_items: 'Reduction measures items',
      avoided_emission: 'Avoided emissions (tCO2e)',
      reduction_measures_target: 'Reduction measures target',
      scope_1: 'Scope 1',
      city_gas: 'City gas',
      kerosene: 'Kerosene',
      gasoline: 'Gasoline',
      light_oil: 'Light oil',
      scope_2: 'Scope 2',
      purchased_electricity: 'Purchased electricity',
      start_year: 'Start year',
      reduction_effect_of_investment:
        'Reduction effect of investment (yen/year)',
      status: 'Status',
      on: 'On',
      off: 'Off',
      search_for_reduction_measures: 'Reduction measures',
      products_services: 'Reduction measures products/services',
      co2_avoided_amount: 'Amount of avoided CO2 through introduction (tCO2e)',
      version_name: 'Version Name',
      target_setting_period: 'Target Setting Period',
      creation_date_time: 'Creation Date and Time',
      target_activity: 'Target Activity',
      total_emissions_base_year: 'Total Emissions in Base Year [tCO2e]',
      registered_co2_reduction_measures: 'Registered CO2 reduction measures',
      branch: 'Branch/Facility',
      type: 'Type',
      operation: 'Operation',
      scope_numbers: 'Looking at the numbers',
      graph: 'View the graph',
      goal_setting: 'Target Setting',
      planned_value_optinal: 'Planned Value',
      base_year_and_target_end_year_required:
        '※Please enter the base year and the final year for target setting.',
      production_increase_rate: 'Production Increase Rate:',
      bases_creation_completed_version: 'Base Versions',
      version_status_description:
        "There can be only one 'Completed' target setting per location.\nIf you change another target setting to 'Completed', the current 'Completed' target setting will be changed to 'In Progress'.",
      plan: 'Scope 1, Scope 2 (when no reduction measures are taken)',
      unit: 'Unit (tCO2e)',
      total: 'Total',
      cutoff_table_title: 'Total CO2 reduction',
      plan_after: 'Scope 1, Scope 2 (Plan)',
      co2_emission_rate: 'CO2 Emission Rate',
      growth_rate: 'Production growth rate',
      carbon_productivity: 'Carbon Productivity',
      detail: 'Detail',
      imagine_finished_product: 'Imagine the finished product!',
      re_measures: 'Reduction measures',
      re_measures_with_unit: 'Reduction measures target (tCO2e)',
    },
    placeholder: {
      reduction_measures: 'Switching to energy-efficient air conditioners',
      reduction_measures_detail:
        'By updating your old air conditioner to the latest energy-efficient models, you can significantly reduce your power consumption and the associated CO2 emissions',
      reduction_effect_of_investment: '-1,200,000 yen',
      please_select: 'Please select',
      scope:
        'When you select a reduction measure target, the scope will be displayed',
      target: 'Please search for the content that you would like to reduce',
      filter: 'Reduction measures, facilities/bases...',
      goal_version_name: 'Example: setting targets for fiscal year 2024',
      sample_target: 'Reduce emissions by half by 2030!',
      sub_sample_target: "Let's write the medium to long-term slogan here!",
      sub_sample_year: 'Please enter the final year for your target setting!',
      search_reduction_measures: 'Search for the reduction measures',
    },
    button: {
      register: 'Register',
      search_for_reduction_measures: 'Search for reduction measures',
      add_your_own_reduction_measures: 'Add your own reduction measures',
      create_goal_version: 'Create target version',
      to_the_list: 'To the list screen',
    },
    message: {
      no_cutoff_data: 'Add some reduction measures',
      no_cutoff_data_with_link:
        '<span>Add some <a>reduction measures</a>.</span>',
      no_data: 'There are no data',
      emission_strategy_exist: 'Reduction measures is existed',
      plan_is_required: 'Please enter the planned value.',
      no_version: 'There is no versions',
      no_search_data: 'There are no refined results',
      version_completed_is_required:
        "Please register the reduction targets with the 'Completed' status.",
      viewer_version_completed_is_required:
        "No reduction target has been set at the parent user's location",
      version_branch_is_required: 'Please create a version.',
      exceed_length_name_version:
        'Please enter the version name within 100 characters.',
    },
    version_status: {
      preparing: 'Preparing',
      in_progress: 'In progress',
      completed: 'Completed',
    },
    dashboard: {
      step: {
        title_completed_image: 'View examples of CO2 reduction targets',
        description_completed_image:
          "Let's first check an example to see how it will look when the reduction target settings are complete",
        button_completed_image: 'View examples of completed reduction targets',
        title_reduction_numbers: 'View the list of CO2 reduction measures',
        description_reduction_numbers:
          'Check out the example menu of C02 reduction measures and get an idea of ​​what it would look like when filled out',
        button_reduction_numbers: 'View the list of CO2 reduction measures"',
        title_reduction_measures: 'View CO2 reduction images',
        description_reduction_measures:
          "Let's imagine the numbers in the reduction plan and the numbers when the reduction measures are implemented.",
        button_reduction_measures: 'View images related to CO2 reduction',
      },
      sections: {
        title_reduction_number_setting: 'STEP 1: Reduction Number Setting',
        description_reduction_number_setting:
          'Register specific reduction measures that your organization can take to reduce C02 emissions. The contents registered here can be reused and will also be available for annual reduction measure reports.',
        title_scope_reduction_plan: 'Reduction measures plan',
        demo_title_scope_reduction_plan: 'Demo page of the completed example',
        step_2_title_scope_reduction_plan: 'STEP 2: Reduction measures plan',
        description_scope_reduction_plan:
          'Create reduction plans by scope that your organization can implement to reduce C02 emissions. This section allows you to set numerical values to reduce the usage of gas, electricity, etc.',
        title_reduction_forecast_simulation:
          'STEP 3: CO2 reduction forecast image',
        description_reduction_forecast_simulation:
          'Based on the current emission data and reduction measures above, you can check the forecasted numbers for the overall reduction measures.',
      },
    },
    chart: {
      co2_reduction_plan: 'CO2 reduction plan',
      scope_1_plan: 'Scope 1 (Plan)',
      scope_2_plan: 'Scope 2 (Plan)',
      scope_1_actual: 'Scope 1 (Actual)',
      scope_2_actual: 'Scope 2 (Actual)',
      company: 'Organization',
      facility: 'Facility',
      carbon_productivity_plan: 'Carbon Productivity Plan',
      co2_emission_rate: 'CO2 Emission Rate',
      production_increase_rate: 'Production Increase Rate',
      carbon_productivity:
        'Carbon Productivity (Production Increase Rate/CO2 Emission Rate)',
    },
  },
  placeholder: {
    filter: 'Filter',
    date: 'YYYY/MM/DD',
  },
  item: {
    create: {
      form: {
        title: 'Add Item',
        name: {
          label: 'Item Name',
          place_holder: 'National average emission factor',
        },
        class: {
          label: 'Classification',
        },
      },
    },
  },
  pagination: {
    total:
      'Displaying <big>{{firstItem}}</big>~<big>{{lastItem}}</big> of <big>{{totalItems}}</big>',
    display_number: 'Number of items displayed',
  },
  invoice_ocr: {
    title: 'Register from invoices (AI reading)',
    sub_title:
      'Upload electricity, gas or fuel invoices and AI reads the usage to prepare registrations',
    step_scope: '1. Invoice type',
    scope1: 'Scope1 (gas / fuel)',
    scope2: 'Scope2 (electricity / heat)',
    scope3: 'Scope3',
    step_branch: '2. Facility (optional)',
    branch_hint:
      'Select a facility if all invoices belong to it. Otherwise AI estimates the facility from the addressee and supply location.',
    branch_auto: 'Let AI estimate',
    branch_label: 'Facility',
    usage_month: 'Usage month',
    step_upload: '3. Upload invoices',
    drop_here: 'Drop invoices here',
    drop_note: 'PDF / JPG / PNG / HEIC (up to 10MB)',
    remove: 'Remove',
    read_button: 'Read with AI',
    reading: 'Reading…',
    reset: 'Start over',
    note_1:
      '- AI is used for reading. Each file takes about 10-30 seconds (up to 20 files at once).',
    note_2:
      '- Nothing is registered yet. Review and correct the rows below, then register.',
    note_3:
      '- The uploaded invoice is attached to the registered data as evidence.',
    check_title: 'Points to check',
    check_hint:
      'Always check items in red and rows with low confidence. You can correct them in the table below.',
    col: {
      file: 'Invoice',
      read: 'Read values',
      factor: 'Emission factor',
      confidence: 'Confidence',
      points: 'Points to check',
    },
    confidence: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    status: {
      waiting: 'Not read',
      reading: 'Reading',
      done: 'Done',
      warning: 'Check',
      error: 'Failed',
      rows: '{{count}} registration(s) prepared',
    },
    errors: {
      too_many: 'You can read up to {{max}} files at once',
      ai_failed: 'AI reading failed. Please try again later',
      unknown: 'Reading failed',
    },
  },
}
